import { jsx as _jsx } from "react/jsx-runtime";
import { ContainerView } from './container_view';
export const ResourcesPreview = ({ messages }) => {
    if (!messages) {
        return null;
    }
    return (_jsx(ContainerView, { children: _jsx("div", { style: { padding: '2rem', wordBreak: 'break-word' }, children: Object.keys(messages)
                .sort()
                .map((message) => (_jsx("div", { dangerouslySetInnerHTML: { __html: messages[message] } }, messages[message]))) }) }));
};
//# sourceMappingURL=resources.preview.component.js.map